import React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  Button as MuiButton,
} from "@mui/material";

export interface SignupProfessionalStepThreeProps {
  items: { id: number; label: string; selected: boolean }[];
  onChange: (item: any) => void;
  selectedItem: number[];
}

const SignupProfessionalStepThree = ({
  items,
  onChange,
  selectedItem,
}: SignupProfessionalStepThreeProps) => {
  return (
    <Stack justifyContent="center" alignItems="center" spacing={5}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1" fontWeight={700}>
          What is your main reason for joining Eventview360?
        </Typography>
        <Typography variant="h4" fontWeight={500}>
          Pick 1 or multiple reasons
        </Typography>
      </Stack>
      <Stack width="50%" spacing={2}>
        <Stack spacing={0.5}>
          {items &&
            items.map((item: any) => {
              return (
                <MuiButton
                  id={item.id}
                  className="font-black"
                  style={{
                    border: `1px solid ${
                      selectedItem.find((select) => select === item.id)
                        ? `#B1D238`
                        : `#C4C4C4`
                    }`,
                  }}
                  onClick={() => onChange(item)}
                >
                  {item.label}
                </MuiButton>
              );
            })}
        </Stack>

        <Box mt={2}>
          <Button variant="contained" type="submit" color="primary" fullWidth>
            Next
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
};
export default SignupProfessionalStepThree;
